import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "h-4 w-4 fill-current text-gray-500",
  viewBox: "0 0 19 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "clip-path": "url(#clip0_2212_5570)"
    }, [
      _createElementVNode("path", { d: "M18.084 4.404a12.2 12.2 0 0 0-8.776-.108 12.2 12.2 0 0 0-8.777.108.85.85 0 0 0-.531.784v12.694a.843.843 0 0 0 .755.84.85.85 0 0 0 .405-.056 10.52 10.52 0 0 1 7.833 0h.012q.131.049.27.052c.013 0 .023.006.033.006s.03-.006.046-.007q.075-.004.15-.022l.076-.02q.021-.002.042-.011a10.52 10.52 0 0 1 7.833 0 .848.848 0 0 0 1.16-.782V5.188a.84.84 0 0 0-.531-.784M8.462 16.7a12.2 12.2 0 0 0-6.77 0V5.776a10.5 10.5 0 0 1 6.77 0zm8.461 0a12.2 12.2 0 0 0-6.769 0V5.776a10.5 10.5 0 0 1 6.77 0z" })
    ], -1)
  ])))
}
export default { render: render }